import { IconSize } from '@constants';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { Box, styled } from '@mui/material';

interface ChevronProps {
  attrs: { active: boolean };
}

export const BoxPaginationStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  borderRadius: theme.spacing(1),
  gap: theme.spacing(4),
  padding: theme.spacing(2, 3),
  display: 'inline-flex',
  alignItems: 'center',
}));

export const BoxControllerPageStyled = styled(Box)(({ theme }) => ({
  gap: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
}));

export const ChevronLeftStyled = styled(ChevronLeftIcon)<ChevronProps>(
  ({ theme, attrs }) => ({
    opacity: attrs.active ? 1 : 0.3,
    color: attrs.active
      ? theme.palette.primary.dark
      : theme.palette.dark.dark_3,
    cursor: attrs.active ? 'pointer' : 'inherit',

    width: IconSize.sm,
    height: IconSize.sm,
  }),
);

export const ChevronRightStyled = styled(ChevronRightIcon)<ChevronProps>(
  ({ theme, attrs }) => ({
    opacity: attrs.active ? 1 : 0.3,
    color: attrs.active
      ? theme.palette.primary.dark
      : theme.palette.dark.dark_3,
    cursor: attrs.active ? 'pointer' : 'inherit',

    width: IconSize.sm,
    height: IconSize.sm,
  }),
);
